import React, { useState, useEffect } from 'react'
import { useParams, useNavigate, useSearchParams } from 'react-router-dom'
import axios from 'axios'
import { Lock, AlertCircle } from 'lucide-react'
import WayPlayer from '../../components/player/WayPlayer'

const apiUrl = import.meta.env.VITE_APP_API

function CourseVideo() {
    const { courseSlug, videoId } = useParams()
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()

    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const [isEnrolled, setIsEnrolled] = useState(false)

    // Get time parameter from URL
    const timeParam = searchParams.get('t')

    // Get authentication token
    const access_token = JSON.parse(localStorage.getItem("faceAuthTokenData"))?.token?.access

    useEffect(() => {
        if (access_token) {
            checkEnrollmentStatus()
        } else {
            setLoading(false)
            setError('Please login to access course videos')
        }
    }, [courseSlug, access_token])

    // Check if user is enrolled in the course
    const checkEnrollmentStatus = async () => {
        try {
            setLoading(true)
            const response = await axios.get(`${apiUrl}/api/course/enroll_check_by_slug/${courseSlug}`, {
                headers: {
                    Authorization: `Bearer ${access_token}`
                }
            })
        } catch (error) {
            console.error('Error checking enrollment:', error)
            if (error.response?.status === 401) {
                setError('Please login to access course videos')
            } else {
                setError('Failed to verify course enrollment')
            }
        } finally {
            setLoading(false)
        }
    }

    // Loading state
    if (loading) {
        return (
            <div className="min-h-screen bg-gray-50 flex items-center justify-center">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
                    <p className="text-gray-600">Loading course video...</p>
                </div>
            </div>
        )
    }

    // Error state
    if (error) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-red-50 to-pink-50 flex items-center justify-center px-4">
                <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
                    <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                        {error.includes('login') ? (
                            <Lock className="w-8 h-8 text-red-500" />
                        ) : (
                            <AlertCircle className="w-8 h-8 text-red-500" />
                        )}
                    </div>
                    <h2 className="text-2xl font-bold text-gray-800 mb-4">Access Denied</h2>
                    <p className="text-gray-600 mb-8">{error}</p>
                    <div className="space-y-3">
                        {error.includes('login') ? (
                            <button
                                onClick={() => navigate('/login')}
                                className="w-full bg-blue-500 hover:bg-blue-600 text-white py-3 px-6 rounded-lg font-medium transition-colors"
                            >
                                Login Now
                            </button>
                        ) : (
                            <button
                                onClick={() => navigate(`/courses/${courseSlug}`)}
                                className="w-full bg-orange-500 hover:bg-orange-600 text-white py-3 px-6 rounded-lg font-medium transition-colors"
                            >
                                Enroll in Course
                            </button>
                        )}
                        <button
                            onClick={() => navigate('/')}
                            className="w-full text-gray-600 hover:text-gray-800 py-2 font-medium transition-colors"
                        >
                            Go to Homepage
                        </button>
                    </div>
                </div>
            </div>
        )
    }

    // Show YouTube video if enrolled
        return (
            <div className=" flex flex-col items-center justify-center my-10 mt-24">
                {/* Headline */}
                <h1 className="text-3xl font-bold text-gray-800 mb-8 text-center">
                    টপিকভিত্তিক ক্লাস
                </h1>
                
                <div className="w-full max-w-7xl px-4" style={{ aspectRatio: "16/9" }}>
                        <WayPlayer
                            videoId={videoId}
                            startTime={timeParam ? parseInt(timeParam) : 0}
                            options={{
                                poster: `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`,
                            }}
                        />
                </div>
            </div>
        )
    }

export default CourseVideo